<!--
 * @Author: chenxing
 * @Date: 2021-03-30 22:36:31
 * @LastEditors: LiuXin
 * @LastEditTime: 2021-08-25 17:15:44
-->
<template>
  <div class="user bcg_w">
    <div class="user-content">
      <a-row class="user-title" type="flex" justify="center" align="top">
        <a-page-header title="用户信息" />
      </a-row>
      <a-row class="userMessage" :align="'middle'">
        <a-col :span="12">
          <a-form-item label="用户名/花名" :label-col="{ span: 6 }" :wrapper-col="{ span: 16 }">{{ createUserFormData.userCode }}</a-form-item>
        </a-col>
        <a-col :span="3">
          <a-button type="primary" @click="onUpdatePasswordBtnClick">修改密码</a-button>
        </a-col>
      </a-row>
      <a-row class="userMessage" :align="'middle'">
        <a-col :span="12">
          <a-form-item label="姓名" :label-col="{ span: 6 }" :wrapper-col="{ span: 16 }">{{ createUserFormData.name }}</a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item label="性别" class="sex" :label-col="{ span: 6 }" :wrapper-col="{ span: 16 }">{{ createUserFormData.sex == 'MALE' ? '男' : '女' }}</a-form-item>
        </a-col>
      </a-row>
      <a-row class="userMessage" :align="'middle'">
        <a-col :span="12">
          <a-form-item label="在职状态" class="workStatus" :label-col="{ span: 6 }" :wrapper-col="{ span: 16 }">{{ createUserFormData.workingState == 'WORKING' ? '在职' : '离职' }}</a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item label="邮件" :label-col="{ span: 6 }" :wrapper-col="{ span: 16 }">{{ createUserFormData.email }}</a-form-item>
        </a-col>
      </a-row>
      <a-row class="userMessage" :align="'middle'">
        <a-col :span="12">
          <a-form-item label="部门" :label-col="{ span: 6 }" :wrapper-col="{ span: 16 }">{{ createUserFormData.deptName }}</a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item label="岗位" class="jobs" :label-col="{ span: 6 }" :wrapper-col="{ span: 16 }">{{ columnMap(jobsOptions, createUserFormData.jobs) }}</a-form-item>
        </a-col>
      </a-row>
      <a-row class="userMessage" :align="'middle'">
        <a-col :span="12">
          <a-form-item label="出生日期" :label-col="{ span: 6 }" :wrapper-col="{ span: 16 }">{{ createUserFormData.birthDate }}</a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item label="入职日期" :label-col="{ span: 6 }" :wrapper-col="{ span: 16 }">{{ createUserFormData.hireDate }}</a-form-item>
        </a-col>
      </a-row>
      <a-modal v-model:visible="showUpdatePassword" title="修改密码" class="updateNewPassword" @ok="confirmUpdatePassword" cancel-text="取消" ok-text="确认" :mask-closable="false">
        <a-row class="updateNewPassword-content">
          <a-form ref="updatePassword" :model="createUserFormData" :rules="updatePasswordRule" style="width: 100%">
            <a-col :span="24">
              <a-form-item label="旧密码" name="oldPassword" :label-col="{ span: 4 }" :wrapper-col="{ span: 16 }">
                <a-input-password v-model:value="createUserFormData.oldPassword" placeholder="请输入旧密码" />
              </a-form-item>
            </a-col>
            <a-col :span="24">
              <a-form-item label="新密码" name="newPassword" :label-col="{ span: 4 }" :wrapper-col="{ span: 16 }">
                <a-input-password v-model:value="createUserFormData.newPassword" placeholder="请输入新密码" @change="newPassword" />
              </a-form-item>
            </a-col>
            <a-col :span="24">
              <a-form-item label="确认密码" name="confirmPassword" :label-col="{ span: 4 }" :wrapper-col="{ span: 16 }">
                <a-input-password v-model:value="createUserFormData.confirmPassword" placeholder="请输入确认密码" />
              </a-form-item>
            </a-col>
          </a-form>
        </a-row>
      </a-modal>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { getUserMessageData } from '@/api/user/index.js';
import { message } from 'ant-design-vue';
import { updatePassword } from '@/api/base/user.js';
export default {
  data() {
    return {
      showUpdatePassword: false,
      sexList: [
        {
          label: '男',
          value: '1',
        },
        {
          label: '女',
          value: '0',
        },
      ],
      workStatus: [
        {
          label: '是',
          value: '1',
        },
        {
          label: '否',
          value: '0',
        },
      ],
      createUserFormData: {},
      // 岗位选项
      jobsOptions: [
        { text: 'ADMIN', value: 'ADMIN' },
        { text: '运营', value: 'OPERATION' },
        { text: '编导', value: 'SCENARIST' },
        { text: '制片', value: 'FILEMAKER' },
        { text: '拍摄', value: 'PHOTOGRAPHER' },
        { text: '后期', value: 'POSTER' },
        { text: '媒介', value: 'MEDIUM' },
        { text: '销售', value: 'SELL' },
        { text: '人力', value: 'MANPOWER' },
        { text: '风控', value: 'RISKMANAGER' },
        { text: '财务', value: 'TREASURER' },
        { text: '技术', value: 'EXPLOIT' },
        { text: '其他', value: 'OTHER' },
      ],
      updatePasswordRule: {
        oldPassword: { required: true, message: '请输入旧密码', trigger: 'blur' },
        newPassword: [
          { required: true, message: '请输入新密码', trigger: 'blur' },
          { min: 5, max: 12, message: '新密码在6~12之间', trigger: 'blur' },
        ],
        confirmPassword: [{ required: true, message: '请输入确认密码', trigger: 'blur' }],
      },
    };
  },
  computed: {
    ...mapState({
      userId: state => state.oauth.userInfo.userId,
    }),
  },
  mounted() {
    this.getUserMessage();
  },
  methods: {
    newPassword() {
      this.createUserFormData.newPassword = this.createUserFormData.newPassword.trim();
    },
    columnMap(arrList, key) {
      if (key) {
        return arrList.filter(item => {
          return item.value == key;
        })[0].text;
      }
    },
    async getUserMessage() {
      let res = await getUserMessageData(this.userId);
      this.createUserFormData = res.user;
    },
    onUpdatePasswordBtnClick() {
      this.showUpdatePassword = true;
      this.createUserFormData.oldPassword = '';
    },
    confirmUpdatePassword() {
      this.$refs.updatePassword.validate().then(() => {
        if (this.createUserFormData.newPassword !== this.createUserFormData.confirmPassword) {
          message.error('新密码和确认密码不一致!');
          this.createUserFormData.newPassword = '';
          this.createUserFormData.confirmPassword = '';
        } else {
          let passwordParams = {};
          passwordParams.password = this.createUserFormData.oldPassword;
          passwordParams.newPassword = this.createUserFormData.newPassword;
          updatePassword(passwordParams).then(res => {
            if (res.code === 0) {
              message.success('密码修改成功!');
              this.showUpdatePassword = false;
            }
          });
        }
      });
    },
  },
};
</script>

<style lang="less">
.user {
  width: 100%;
  height: 100%;
  border-radius: 8px;
  text-align: center;
  display: flex;
  justify-content: center;
  .user-content {
    width: 42%;
    padding: 20px;
    .userMessage {
      height: 90px;
      .ant-form-item {
        margin-bottom: 0;
        .ant-form-item-control-wrapper,
        .ant-form-item-label {
          text-align: left;
          height: 40px;
        }
      }
    }
  }
}
</style>
